import * as type from "./type";

const initialState = {
  list: [],
  unreadCount: 0,
  totalRecords: 0,
  loading: false,
};

/* The badge is kept even while a fresh list is loading - blanking it would
   make the header flicker to zero every time the panel is opened. */
const NotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_NOTIFICATION_LIST_REQUEST:
      return { ...state, loading: true };
    case type.GET_NOTIFICATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload?.list || [],
        unreadCount: action.payload?.unreadCount ?? state.unreadCount,
        totalRecords: action.payload?.totalRecords || 0,
      };
    case type.GET_NOTIFICATION_COUNT_SUCCESS:
      return {
        ...state,
        unreadCount: action.payload?.unreadCount ?? state.unreadCount,
      };
    case type.READ_NOTIFICATION_SUCCESS:
      return {
        ...state,
        unreadCount: action.payload?.unreadCount ?? state.unreadCount,
      };
    case type.CLEAR_NOTIFICATIONS:
      return { ...initialState };
    default:
      return { ...state };
  }
};

export default NotificationReducer;
